import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M3.9 21.5a.6.6 0 1 0 1.2 0v-19a.6.6 0 1 0-1.2 0v19Zm5.6-10.1a.6.6 0 0 0 0 1.2h8.551l-3.975 3.976a.6.6 0 1 0 .848.848l5-5a.6.6 0 0 0 0-.848l-5-5a.6.6 0 0 0-.848.848L18.05 11.4H9.5Z"
    />
  </svg>
`;
